import React from 'react'
import SingleLatestTransaction from './SingleLatestTransaction'
import {Typography,Button, Grid, Link} from '@mui/material';
import colors from '../../../colors'
import Lottie from "lottie-react";
import noTransactionsAnimation from '../../../../icons/lottieAnimations/noTransactions.json'
import { useNavigate }  from "react-router-dom";
import { texts } from '../../../general/texts';
import {selectUserInfo} from '../../../../features/userInfo/userInfoSlice';
import { useSelector } from 'react-redux';

const LatestTransactions = () =>
{
    const navigate = useNavigate()
    const userInfoSliceState = useSelector(selectUserInfo)

    return(
        <Grid container item md={7} xs={12} justifyContent={'left'}  sx={{'@media (max-width: 899px)' : {justifyContent:'center', width:'60%'}}} >
            <Grid elevation={0} sx={{background:colors.cyan,'@media (max-width: 1440px)' : {width:'100%'}, '@media (max-width: 899px)' : {width:'80%'}}}  >
                <Grid container item md={12} pl={'2%'} pb={'8%'} >
                    <Typography sx={{color:colors.darkBlue, fontFamily:'GerberaBold', fontSize:'1.5rem'}}>{texts["propmt-statements"]}</Typography>
                </Grid>
                {userInfoSliceState.defaultTransactionHistory && userInfoSliceState.defaultTransactionHistory.transactions.length > 0 ? 
                <Grid container pl={'2%'}  >
                <Grid item md={12} xs={12} >
                    {userInfoSliceState.defaultTransactionHistory.transactions.slice(0,3).map((transactionData, index) => 
                    {
                        return <SingleLatestTransaction key={index} transactionData={transactionData}/>
                    })}              
                </Grid>
                <Grid item justifyContent='flex-start'>
                    <Link component='button' onClick={()=>{navigate('/history')}} sx={{color:colors.orange, textDecoration:'none', ":hover":{textDecorationColor:colors.orange, textDecoration:'underline'}}} pb={'10%'} ><Typography sx={{fontFamily:'GerberaLight'}} >{texts["prompt-more"] + ' >'}</Typography></Link>
                </Grid>
            </Grid>
                :
            <Grid container justifyContent={'center'}>
                <Grid container item md={6} xs={6} justifyContent={'center'} ><Lottie animationData={noTransactionsAnimation} loop={true} autoplay={true}/></Grid>
                <Grid container item md={12} xs={12} justifyContent={'center'} ><Typography sx={{fontFamily:'GerberaBold', textTransform:'none', color:colors.darkBlue}} pb={'7%'}>{texts["message-no-transaction"]}</Typography></Grid>
                <Grid container  item md={9} xs={9} justifyContent={'center'} pt={2} onClick={()=>{navigate('/onpayments')}}><Button sx={{backgroundColor:"#365472", color:colors.white, fontFamily:'GerberaBold', width:'200px',  borderRadius:'8px', textTransform: 'none', ":hover":{background:colors.darkBlue} }}>{texts["prompt-start-now"]}</Button></Grid>
            </Grid> 
                }
            </Grid>
        </Grid>
    )
}
export default LatestTransactions